import 'styles/pages/markdown.scss';
import '~scripts/main';

// Packages
import hljs from 'highlight.js';

// Blocks
import Header from '~scripts/blocks/header';
import Navigation from '~scripts/blocks/navigation';
import initRequestForm from '~scripts/blocks/request-form';

// Components
import '~scripts/components/modals';

//
// NAVIGATION
//
Navigation();

//
// HEADER
//
Header();

//
// FORM
//
const demoRequestForms = document.querySelectorAll('.js-demo-request-form');

demoRequestForms.forEach((form) => {
  initRequestForm(form);
});

//
// highlight code
//

document.querySelectorAll('pre code').forEach((item) => {
  hljs.highlightElement(item);
});

//
// anchor scroll
//
const tocLinks = document.querySelectorAll('.markdown a');
const headerHeight = document.getElementById('header').offsetHeight;

tocLinks.forEach((item) => {
  item.addEventListener('click', (e) => {
    const itemLink = item.getAttribute('href');

    if (itemLink[0] === '#') {
      e.preventDefault();

      const id = item.getAttribute('href').replace(/#/g, '');
      const yOffset = (headerHeight + 20) * -1;
      const element = document.getElementById(id);
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  });
});

// unwrap time tag
// markdown wraps <time> in <p>
const time = document.querySelector('time');

if (time) {
  time.parentElement.replaceWith(...time.parentElement.childNodes);
}
